type route = 'view' | 'edit' | null;
type errorType = 'inherited' | 'view' | null;

export class SSRPermissionsErrorHandler {
	private hasSSRPreloadPermissionsErrorForRoute: route;
	private errorType: errorType;

	constructor() {
		this.hasSSRPreloadPermissionsErrorForRoute = null;
		this.errorType = null;
	}

	public markSSRPreloadPermissionError(route: route, error?: any): void {
		this.hasSSRPreloadPermissionsErrorForRoute = route;
		if (error) {
			this.errorType =
				error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key ===
				'confluence.content.restricted.inherited'
					? 'inherited'
					: 'view';
		}
	}

	public getRestrictedRoute(): route {
		return (
			this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null
		);
	}

	public getErrorType(): any {
		return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
	}
}
